import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "config/config";
import { getApiCall } from "services/apiHelper";

interface PropertyDetailssState {
    data: PropertyDetailsResponse;
    loading: boolean;
    error: string | null;
}

interface PropertyDetailsResponse {
    message: string;
    result: PropertyDetails[];
}

interface PropertyDetails {
    propertyNumber: string;
    propertyName: string;
    investmentNumber: string;
    investmentName: string;
    propertyStatus: string;
}

const initialState: PropertyDetailssState = {
    data: {
        message: "",
        result: []
    },
    loading: false,
    error: null
};

export const getPropertyData = createAsyncThunk("getPropertyData", async (payload: string, { rejectWithValue }) => {
    try {
        var url = `${baseUrl}property/GetByInvId/${payload}`;
        const response = await getApiCall<PropertyDetailsResponse>(url);
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})` || error.message);
    }
})

const propertyDataSlice = createSlice({
    name: 'propertyData',
    initialState,
    reducers: {
        resetState: (state) => {
            state.data = {
                message: "",
                result: []
            };
            state.error = "";
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getPropertyData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getPropertyData.fulfilled, (state, action: PayloadAction<PropertyDetailsResponse>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getPropertyData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    }

});

export const { resetState: resetPropertyData } = propertyDataSlice.actions;
export default propertyDataSlice.reducer;
